module.exports = __webpack_public_path__ + "f76538fbcede18b2389da712cba8165b.svg";